import styles from "./index.module.css";
import dateIcon from "../../assets/icons/Date-icon.png";
import timeIcon from "../../assets/icons/Hour@2x-8.png";
import "react-datepicker/dist/react-datepicker.css";
import DatePickerInput from "react-datepicker";
import { useEffect, useState } from "react";
import moment from "moment";
import Select from "../Select/Select";

const DatePicker = (props) => {
  const {
    selected,
    onChange,
    timeInterval,
    placeholder,
    name,
    showTimeSelect,
    errors,
    format,
    hideTime,
    minYear = 2000,
    maxYear = new Date().getFullYear() + 5,
  } = props;
  const [date, setDate] = useState(null);
  useEffect(() => {
    if (selected) {
      const dateFormated = moment(selected).format(
        `${format ?? "MMMM D, yyyy h:mm a"}`,
      );
      setDate(dateFormated);
    }
  }, [selected]);
  function getYear(date) {
    return new Date(date).getFullYear();
  }
  function getMonth(date) {
    return new Date(date).getMonth();
  }

  const startYear = minYear;
  const endYear = maxYear;

  const years = Array.from(
    { length: endYear - startYear + 1 },
    (_, i) => startYear + i,
  );
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const handleChange = (datePicker) => {
    if (name) {
      onChange({ target: { name, value: datePicker } });
    } else {
      onChange(datePicker);
    }
    const dateFormated = moment(datePicker).format(
      `${format ?? "MMMM D, yyyy h:mm a"}`,
    );
    setDate(dateFormated);
  };
  return (
    <div>
      <DatePickerInput
        renderCustomHeader={({ date, changeYear, changeMonth }) => (
          <div className={styles.headerContainer}>
            <div>
              <Select
                value={getYear(date)}
                onChange={(e) => changeYear(e.value.value)}
                options={years.map((option) => {
                  return { value: option, name: option };
                })}
                large="large"
              />
            </div>
            <div>
              <Select
                value={months[getMonth(date)]}
                onChange={({ value: { value } }) =>
                  changeMonth(months.indexOf(value))
                }
                options={months.map((option) => {
                  return { value: option, name: option };
                })}
                large="large"
              />
            </div>
          </div>
        )}
        selected={selected}
        onChange={handleChange}
        showTimeSelect={showTimeSelect}
        timeIntervals={timeInterval}
        timeCaption="Time"
        dateFormat="MMMM D, yyyy h:mm aa"
        customInput={
          <div className={`${styles.input} ${errors && styles.error}`}>
            <span className={date ? styles.span : styles.placeholder}>
              {date ?? placeholder}
            </span>
            <div className={styles.iconsContainer}>
              <img src={dateIcon} alt="date" className={styles.dateIcon} />
              {!hideTime && (
                <img src={timeIcon} alt="time" className={styles.timeIcon} />
              )}

              {date && (
                <button
                  className={styles.clearButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    setDate(null);
                  }}
                >
                  ✕
                </button>
              )}
            </div>
          </div>
        }
      />
    </div>
  );
};

export default DatePicker;
